var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoveIcon = function SvgMoveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "currentColor",
    viewBox: "0 0 13 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.307 6.525 10.592 4.81a.676.676 0 0 0-.955.955l.563.563H6.927V3.055l.563.563a.67.67 0 0 0 .478.197.676.676 0 0 0 .478-1.152L6.73.948a.676.676 0 0 0-.955 0L4.059 2.663a.676.676 0 0 0 .955.955l.564-.563v3.27H2.304l.564-.563a.676.676 0 0 0-.955-.955L.197 6.523a.68.68 0 0 0 0 .955l1.716 1.715a.676.676 0 0 0 .955-.955l-.564-.563h3.271v3.271l-.563-.564a.676.676 0 0 0-.955.955l1.715 1.716a.676.676 0 0 0 .955 0l1.716-1.716a.68.68 0 0 0 0-.955.68.68 0 0 0-.955 0l-.564.564V7.677h3.271l-.563.564a.68.68 0 0 0 0 .955.676.676 0 0 0 .955 0l1.716-1.716a.67.67 0 0 0 .196-.477.65.65 0 0 0-.192-.478"
  })));
};
export default SvgMoveIcon;